
const progressBar = document.querySelector('.header--statusbar');
const progressVal = document.querySelector('.header--statusbar-wrapper > span');
const section = document.querySelector('body');

const scrollProgressBar = () => {
    let scrollDistance = -(section.getBoundingClientRect().top);
    let progressPercentage =
        (scrollDistance /
            (section.getBoundingClientRect().height -
                document.documentElement.clientHeight)) * 100;

    let val = Math.round(progressPercentage);
    progressBar.style.width = val + '%';
    progressVal.innerHTML = val + '%';
    if (val < 0) {
        progressBar.style.width = '0%';
        progressVal.innerHTML = '0%';
    }
};

window.addEventListener('scroll', scrollProgressBar);